import { useEffect, useState } from "react";
import { usePageMeta } from "@/lib/seo";
import { apiClient } from "@/lib/api";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQ() {
  usePageMeta("FAQ", "Frequently asked questions about ordering, shipping, COAs, and Research Use Only compliance.", "/faq");
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    apiClient.get("/faqs").then((res) => setFaqs(res.data)).catch(() => {});
  }, []);

  const grouped = faqs.reduce((acc, f) => {
    acc[f.category] = acc[f.category] || [];
    acc[f.category].push(f);
    return acc;
  }, {});

  return (
    <div className="max-w-3xl mx-auto px-6 md:px-12 py-16" data-testid="faq-page">
      <div className="text-center mb-14">
        <span className="text-xs tracking-[0.2em] uppercase font-semibold text-brandblue-600">Support</span>
        <h1 className="mt-3 text-4xl sm:text-5xl tracking-tighter font-medium text-slate-900 font-display">Frequently Asked Questions</h1>
      </div>

      {Object.entries(grouped).map(([category, items]) => (
        <div key={category} className="mb-10" data-testid={`faq-category-${category.toLowerCase()}`}>
          <h2 className="text-sm font-semibold uppercase tracking-wider text-slate-500 mb-4">{category}</h2>
          <Accordion type="single" collapsible className="space-y-3">
            {items.map((faq) => (
              <AccordionItem key={faq.id} value={faq.id} className="border border-slate-200 rounded-2xl px-5 hover:border-blue-200 hover:shadow-blue-glow-sm transition-all duration-300" data-testid={`faq-full-item-${faq.id}`}>
                <AccordionTrigger className="text-sm font-semibold text-slate-900 hover:text-brandblue-700 hover:no-underline">{faq.question}</AccordionTrigger>
                <AccordionContent className="text-sm text-slate-600 leading-relaxed">{faq.answer}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      ))}
    </div>
  );
}
